import { useEffect, useState } from 'react';
import { fetchProductPrices } from '../services/stripe.service';
import {
	ONETIME_PRODUCT_ID,
	PRODUCT_ID_LIBRARY,
	PRODUCT_ID_SINGLE,
	PRODUCT_ID_SUBSCRIPTION,
} from '../config/constants';

// Fetches active prices for all Stripe products on mount.
// Returns separate arrays per product type plus a loading flag.
export const useStripePrices = () => {
	const [subscriptionPrices, setSubscriptionPrices] = useState(null);
	const [singlePrices, setSinglePrices] = useState(null);
	const [oneTimePrices, setOneTimePrices] = useState(null);
	const [libraryPrices, setLibraryPrices] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const productIds = [
			PRODUCT_ID_SUBSCRIPTION,
			PRODUCT_ID_SINGLE,
			ONETIME_PRODUCT_ID,
			PRODUCT_ID_LIBRARY,
		];

		Promise.all(productIds.map((id) => fetchProductPrices(id)))
			.then(([subscription, single, oneTime, library]) => {
				setSubscriptionPrices(subscription);
				setSinglePrices(single);
				setOneTimePrices(oneTime);
				setLibraryPrices(library);
			})
			.finally(() => setLoading(false));
	}, []);

	return {
		subscriptionPrices,
		singlePrices,
		oneTimePrices,
		libraryPrices,
		loading,
	};
};
